import * as types from "../actions/actionTypes";
const initialState = {
  inProcess: false,
  loading: true,
  data: {
    data: {},
    message: []
  },
  dataList: {
    data: [],
    message: []
  }
};

const ActivityWageRate = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_WAGE_RATE_LIST_REQUEST:
      return { ...state, loading: true };
    case types.GET_WAGE_RATE_LIST_SUCCESS:
      return { ...state, dataList: action.payLoad, loading: false };
    case types.GET_WAGE_RATE_LIST_FAILURE:
      return { ...state, loading: false };

    case types.WAGE_RATE_CREATE_REQUEST:
      return { ...state, inProcess: true };
    case types.WAGE_RATE_CREATE_SUCCESS:
      return {
        ...state,
        data: action.payLoad,
        inProcess: false
      };
    case types.WAGE_RATE_CREATE_FAILURE:
      return { ...state, ...action.payLoad, inProcess: false };

    case types.WAGE_RATE_UPDATE_REQUEST:
      return { ...state, inProcess: true };
    case types.WAGE_RATE_UPDATE_SUCCESS:
      return { ...state, ...action.payLoad, inProcess: false };
    case types.WAGE_RATE_UPDATE_FAILURE:
      return { ...state, ...action.payLoad, inProcess: false };

    case types.WAGE_RATE_DELETE_REQUEST:
      return { ...state, inProcess: true };
    case types.WAGE_RATE_DELETE_SUCCESS:
      const index = state.dataList.data.findIndex(
        item => item.id === action.id
      );
      return {
        ...state,
        dataList: {
          ...state.dataList,
          data: [
            ...state.dataList.data.slice(0, index),
            ...state.dataList.data.slice(index + 1)
          ]
        },
        inProcess: false
      };
    case types.WAGE_RATE_DELETE_FAILURE:
      return { ...state, inProcess: false };

    default:
      return state;
  }
};

export default ActivityWageRate;
